import {
  TReceivedInvoiceCondition,
  TSetupConditionProps,
} from '@/context/services/invoice/type';
import { useReceivedInvoiceOperationStatusOptions } from '@/features/invoices/hooks/useReceivedInvoiceOperationStatusOptions';
import { useRenewalUiReceivedInvoicesFlag } from '@/hooks/feature_flag/useRenewalUiReceivedInvoicesFlag';
import { useTranslation } from '@/i18n';
import {
  FormCheckboxGroup,
  FormFields,
  FormSelect,
  type SelectProps,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import styles from './OperationStatus.module.scss';

const cx = classnames.bind(styles);

export const OperationStatus: FC<TSetupConditionProps> = memo(
  ({ control, name }) => {
    const { t } = useTranslation();
    const isRenewalUiReceivedInvoices = useRenewalUiReceivedInvoicesFlag();
    const { selectOptions, checkboxOptions } =
      useReceivedInvoiceOperationStatusOptions();
    const labelProps = useMemo(
      () => ({
        text: t('label_operation_status'),
        testId: 'invoice-search-operation-status-label',
      }),
      [t]
    );
    const selectProps: SelectProps = useMemo(
      () => ({
        options: selectOptions,
        maxTagCount: 1,
        mode: 'multiple',
      }),
      [selectOptions]
    );

    if (!isRenewalUiReceivedInvoices) {
      return (
        <FormSelect<TReceivedInvoiceCondition>
          control={control}
          name={name}
          selectProps={selectProps}
          label={labelProps}
          inputId='invoice-search-operation-status'
          testId='invoice-search-operation-status'
        />
      );
    }

    return (
      <div className={cx(styles.container)}>
        <FormFields label={labelProps}>
          <FormCheckboxGroup<TReceivedInvoiceCondition>
            control={control}
            name={name}
            options={checkboxOptions}
            testId='invoice-search-operation-status'
            vertical={false}
            className={cx(styles.checkboxGroup)}
          />
        </FormFields>
      </div>
    );
  }
);
OperationStatus.displayName = 'OperationStatus';
